import { render } from "./UserRegistration.component.vue?vue&type=template&id=29ceac01&scoped=true&ts=true"
import script from "./UserRegistration.component.vue?vue&type=script&lang=ts"
export * from "./UserRegistration.component.vue?vue&type=script&lang=ts"

import "./UserRegistration.component.vue?vue&type=style&index=0&id=29ceac01&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29ceac01"]])

export default __exports__